import React from 'react';
import { Outlet } from 'react-router-dom';

import { MobileAppBar } from '@/components/Layout/mobile/MobileAppBar';
import { useIsMobileViewport } from '@/hooks/useIsMobileViewport';

interface ProfilePageProps {}

const ProfilePage: React.FC<ProfilePageProps> = () => {
  const isMobileViewport = useIsMobileViewport();

  return (
    <>
      {isMobileViewport ? <MobileAppBar title="Profile" /> : null}
      <Outlet />
    </>
  );
};

export default ProfilePage;
